import(/* webpackMode: "eager", webpackExports: ["message","success","error"] */ "__barrel_optimize__?names=message!=!/www/wwwroot/STARY-bc/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tag"] */ "__barrel_optimize__?names=Tag!=!/www/wwwroot/STARY-bc/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/STARY-bc/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/STARY-bc/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Blogs/BlogContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Blogs/BlogSeach.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Blogs/Categories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Blogs/Tags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/Home/banner.tsx");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/STARY-bc/src/components/homeComponent/FreshBlog.tsx");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/STARY-bc/src/components/homeComponent/How.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/homeComponent/Logos.tsx");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/STARY-bc/src/components/homeComponent/NewCate.tsx");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/STARY-bc/src/components/homeComponent/Reviews.tsx");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/STARY-bc/src/components/homeComponent/SelectedProducts.tsx");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/STARY-bc/src/components/homeComponent/ToHelp.tsx");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/STARY-bc/src/components/homeComponent/Video.tsx");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/STARY-bc/src/components/homeComponent/WeServer.tsx");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/STARY-bc/src/components/homeComponent/Why.tsx");
